import React, { useState } from "react";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function PaymentForm({ offerToSubscribe, apiUrl, token, onSave, onClose, onCancel }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    // 🔹 Nouvel état pour le nombre de crédits
    const [nbCredits, setNbCredits] = useState(1);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            // 🔹 On envoie nbCredits seulement si c'est l'offre crédits likes (ID = 5)
            const body = { offerId: offerToSubscribe.idOffer };
            if (offerToSubscribe.idOffer === 5) body.nbCredits = nbCredits;

            const res = await fetch(`${apiUrl}/api/subscribe/checkout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            });

            const data = await res.json();
            if (data.error) throw new Error(data.error);

            const cardElement = elements.getElement(CardElement);
            if (!cardElement) throw new Error("CardElement introuvable");

            let paymentIntentId = null;

            // 🔹 Paiement ponctuel
            if (data.type === "one_time") {
                const result = await stripe.confirmCardPayment(data.clientSecret, {
                    payment_method: { card: cardElement }
                });

                if (result.error) throw new Error(result.error.message);
                if (result.paymentIntent.status !== "succeeded")
                    throw new Error("Le paiement n'a pas pu être validé.");

                paymentIntentId = result.paymentIntent.id;
                setSuccess(true);

                // 🔹 Passer nbCredits ici pour l'offre ID 5
                await onSave(
                    offerToSubscribe.idOffer,
                    paymentIntentId,
                    "one_time",
                    paymentIntentId, // paymentIntentId
                    nbCredits        // 🔹 nombre de crédits
                );
            }

            // 🔹 Abonnement (SetupIntent)
            else if (data.type === "subscription_setup") {
                const setupResult = await stripe.confirmCardSetup(data.clientSecret, {
                    payment_method: { card: cardElement }
                });

                if (setupResult.error) throw new Error(setupResult.error.message);

                const paymentMethodId = setupResult.setupIntent.payment_method;

                const subRes = await fetch(`${apiUrl}/api/subscribe/createSubscription`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        customerId: data.customerId,
                        priceId: data.priceId,
                        paymentMethodId,
                        metadata: data.metadata,
                        nbCredits, // 🔹 ajouter nbCredits si nécessaire pour abonnement crédits
                    }),
                });

                const subData = await subRes.json();
                if (subData.error) throw new Error(subData.error);

                if (subData.paymentIntentClientSecret) {
                    const confirmResult = await stripe.confirmCardPayment(subData.paymentIntentClientSecret, {
                        payment_method: { card: cardElement }
                    });
                    if (confirmResult.error) throw new Error(confirmResult.error.message);
                    if (confirmResult.paymentIntent.status !== "succeeded")
                        throw new Error("Le paiement initial de l'abonnement n'a pas pu être validé.");

                    paymentIntentId = confirmResult.paymentIntent.id;
                }

                setSuccess(true);
                await onSave(
                    offerToSubscribe.idOffer,
                    subData.subscriptionId,
                    "subscription",
                    paymentIntentId,
                    nbCredits // 🔹 nombre de crédits
                );
            }
        } catch (err) {
            setError(err.message || "Erreur serveur. Veuillez réessayer.");
            console.error(err);
        }

        setLoading(false);
    };

    if (success) {
        return (
            <div style={{ textAlign: "center", padding: "20px" }}>
                <h2>🎉 Félicitations !</h2>
                <p>Vous avez souscrit à l’offre <strong>{offerToSubscribe.titleOffer}</strong>.</p>
                <button onClick={onClose} className="btn btn-primary" style={{ marginTop: "15px" }}>OK</button>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <h2>Souscription à l’offre {offerToSubscribe?.titleOffer}</h2>
            <p>Prix : <strong>{offerToSubscribe?.priceOfferTTC.toFixed(2)} € TTC</strong></p>

            {/* 🔹 Input pour le nombre de crédits (si offre ID = 5) */}
            {offerToSubscribe.idOffer === 5 && (
                <div style={{ marginBottom: "10px" }}>
                    <label>
                        Nombre de crédits :
                        <input
                            type="number"
                            min="1"
                            value={nbCredits}
                            onChange={(e) => setNbCredits(parseInt(e.target.value))}
                            style={{ marginLeft: "10px", width: "60px" }}
                        />
                    </label>
                    <p>Total : <strong>{(offerToSubscribe.priceOfferTTC * nbCredits).toFixed(2)} € TTC</strong></p>
                </div>
            )}

            <div style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "6px" }}>
                <CardElement />
            </div>

            <div style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
                <button type="button" onClick={onCancel} className="btn btn-secondary">Annuler</button>
                <button type="submit" disabled={!stripe || loading} className="btn btn-primary">
                    {loading ? "Paiement en cours..." : "Payer"}
                </button>
            </div>

            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
        </form>
    );
}


export default function OfferFormSubscription({ offerToSubscribe, onClose, onCancel, onSave, apiUrl, token }) {
    return (
        <div className="modal-overlay">
            <div className="modal">
                <Elements stripe={stripePromise}>
                    <PaymentForm
                        offerToSubscribe={offerToSubscribe}
                        apiUrl={apiUrl}
                        token={token}
                        onSave={onSave}
                        onClose={onClose}
                        onCancel = {onCancel}
                    />
                </Elements>
            </div>
        </div>
    );
}
